import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const intimeeldConfig: TSPConfig = {
  key: 'intimeeld',
  name: 'InTimeELD',
  imageName: 'intimeeld',
  category: TSPCategory.API_KEY,
  helpText:
    'Please request an API Key from InTimeELD support. Then input it here.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default intimeeldConfig;
